import { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Typography, Avatar,
    Grid,
    Button,
    DialogContent
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from "@mui/icons-material/Person";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useDispatch, useSelector } from "react-redux";
import { getWorkFlowDetailsService } from "../../../utils/services/workflow.service.ts/workflow-service";
import { closeDialog, openDialog } from "../../../redux/reducer/dialogSlice";
import GlobalDialogContent from "../GlobalDialogContent";
import { RootState } from "../../../redux/store";

const groupWorkflowsByLevel = (workflows: any[]) => {
    return workflows.reduce((acc: any, workflow: any) => {
        if (!acc[workflow.level]) {
            acc[workflow.level] = [];
        }
        acc[workflow.level].push(workflow);
        return acc;
    }, {});
};

const WorkflowHierarchy = ({ workflows }: { workflows: any[] }) => {
    const groupedWorkflows = groupWorkflowsByLevel(workflows);

    return (
        <Box sx={{ mx: 2 }}>
            {Object.entries(groupedWorkflows).map(([level, workflows]) => (
                <Card variant="outlined" key={level} sx={{ marginBottom: 2, border: "2px dashed #ddd", borderRadius: 2, }} >
                    <CardContent >
                        <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold", color: "primary.main", }} > Level {level}</Typography>
                        <Grid container spacing={4}>
                            {(workflows as any[]).map((workflow: any, index: number) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Card sx={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,.25)", height: "100%", display: "flex", flexDirection: "column", }} >
                                        <CardHeader
                                            avatar={
                                                <Avatar sx={{ bgcolor: 'secondary.main' }}>
                                                    <PersonIcon />
                                                </Avatar>
                                            }
                                            title={
                                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                    {workflow.approver_name || '--'}
                                                    {workflow.role_name ? ` (${workflow.role_name})` : ''}
                                                    {workflow.is_dependent === 'Y' ? ' (Dependent)' : workflow.is_dependent === 'N' ? ' (Independent)' : ''}

                                                </Typography>
                                            }
                                        />
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
};

export default function WorkFlowDetails() {
    const dispatch = useDispatch();
    const { payload } = useSelector((state: RootState) => state.dialog);

    const [workflows, setWorkflows] = useState<any>([]);

    useEffect(() => {
        const getWorkFlowDetails = async () => {
            if (payload) {
                const req_payload = {
                    module_id: payload.module_id, ...(payload?.department_id && { department_id: payload.department_id })
                };
                const { data, code } = await getWorkFlowDetailsService(req_payload);
                if (code === 200 && data) {
                    setWorkflows(data);
                }
            }
        }
        getWorkFlowDetails();
    }, [payload])

    const handleEditWorkFlowMaster = (row: any) => {
        dispatch(openDialog({ type: 'EditWorkFlowMaster', title: 'Update Workflow Master', isFullScreen: true, payload: { workflowMaster: row } }));
    }

    return (
        <Box>
            <Box>
                <Card elevation={0}>
                    <CardHeader
                        title={
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6} sx={{ textAlign: 'left', }}>
                                    {workflows[0]?.module_name}
                                    {workflows[0]?.department_name ? ` (${workflows[0]?.department_name})` : ''}
                                </Grid>
                                <Grid item xs={12} sm={6} display={"flex"} justifyContent={"flex-end"}>
                                    <Button variant="outlined" color="primary" endIcon={<EditOutlinedIcon color='info' />} onClick={() => handleEditWorkFlowMaster(payload)} >
                                        Edit Workflow
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    />
                </Card>
            </Box>
            <Box sx={{ maxHeight: "78vh", overflowY: "auto" }}>
                <WorkflowHierarchy workflows={workflows} />
            </Box>
        </Box>
    );
}